// extracted by mini-css-extract-plugin
module.exports = {"container":"Top_container__1Pmd1","logo":"Top_logo__20Ehp","sizer":"Top_sizer__Llcws","userName":"Top_userName__pXvrz","innerContainer":"Top_innerContainer__2Fs3A"};